module.exports = __webpack_public_path__ + "static/media/logo.467a906d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 1001
// module chunks = 0